import React from 'react'
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import UiSwitch from "../../_uiComponents/UiSwitch"
import VisibilityIcon from '@mui/icons-material/Visibility';
import UiTableBody from '../../../_uiComponents/common/table/UiTableBody'
import UiTableHead from '../../../_uiMocks/_uiComponents/UiTableHead'
import UiTableWrapper from '../../../_uiComponents/common/table/UiTableWrapper'
import UiTableProgressBar from '../../../_uiComponents/common/table/UiTableProgressBar';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { UiGridType, NotApprovedIcon, ApprovedIcon, GridStatus, GridActionBar } from "../../../_uiComponents/common/DataGridComponents";


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}


const headings = [
    { id: 'name', name: 'Campaign' },
    { id: 'type', name: 'Type' },
    { id: 'participation', name: 'Participation' },
    { id: 'start', name: 'Start' },
    { id: 'end', name: 'End' },
    { id: 'status', name: 'Status' },
    { id: 'approved', name: 'Approved' },
    { id: '', name: '' },
    { id: '', name: '' },

]
export default function CampaignManagement(props) {

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState();
    const [checked, setChecked] = React.useState(true);
    const [active, setActive] = React.useState();


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };


    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };


    const rows = [
        {
            id: 0,
            name: 'make the call price dr',
            type: 'league individual',
            users: 60,
            start_date: '15/01/2021',
            end_date: '15/01/2021',
            approved: true,
            status: 'ongoing',
            enable: true
        },
        {
            id: 1,
            name: 'q4 rome or away',
            type: 'hit & win',
            users: 20,
            start_date: '15/01/2021',
            end_date: '15/01/2021',
            approved: true,
            status: 'ongoing',
            enable: true
        },
        {
            id: 2,
            name: 'make the call price dr',
            type: 'league team',
            users: 60,
            start_date: '15/01/2021',
            end_date: '15/01/2021',
            approved: false,
            status: 'ongoing',
            enable: false
        },
        {
            id: 3,
            name: 'q4 rome or away',
            type: 'hit & win',
            users: 10,
            start_date: '15/01/2021',
            end_date: '15/01/2021',
            approved: false,
            status: 'disabled',
            enable: true
        },
        {
            id: 4,
            name: 'Big win 2023',
            type: 'prize draw',
            users: 90,
            start_date: '15/01/2021',
            end_date: '15/01/2021',
            approved: false,
            status: 'disabled',
            enable: false
        },
        {
            id: 5,
            name: 'q4 rome or away',
            type: 'hit & win',
            users: 20,
            start_date: '15/01/2021',
            end_date: '15/01/2021',
            approved: false,
            status: 'disabled',
            enable: true
        },
        {
            id: 6,
            name: 'hifh flyers dubai trip',
            type: 'hit & win',
            users: 30,
            start_date: '15/01/2021',
            end_date: '15/01/2021',
            approved: false,
            status: 'disabled',
            enable: true
        },

    ]
    const [newRows, setNewRows] = React.useState(rows);

    const handleChange = (event, index) => {
        let newArr = [...newRows];
        newArr[index].enable = event.target.checked;
        setNewRows(newArr);

    };

    const visibleRows = React.useMemo(
        () =>
            stableSort(rows, getComparator(order, orderBy)).slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
            ),
        [order, orderBy, page, rowsPerPage],
    );
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
    return (
        <>
            <UiTableWrapper>
                <UiTableHead
                    headings={headings}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort} />
                <UiTableBody>
                    {visibleRows.map((row, index) => (
                        <TableRow
                            key={row.id}

                            sx={{ '&:last-child td, &:last-child th': { border: "none" } }}>
                            <TableCell align="left">
                                <strong className='sba-campaign-campaign-cell'>{row.name}</strong>
                            </TableCell>
                            <TableCell align="center"><UiGridType name={row.type} /></TableCell>
                            <TableCell align="center">
                                <UiTableProgressBar
                                    completed={row.users} />
                            </TableCell>
                            <TableCell align="center">{row.start_date}</TableCell>
                            <TableCell align="center">{row.end_date}</TableCell>
                            <TableCell align="center"><GridStatus status={row.status} /></TableCell>
                            <TableCell align="center">{row.approved ? <ApprovedIcon /> : <NotApprovedIcon />} </TableCell>
                            <TableCell align='center'>
                                <UiSwitch
                                    checked={row.enable}
                                    handleChange={(event) => {
                                        handleChange(event, index)
                                    }}
                                    name={row.name} />
                            </TableCell>
                            <TableCell align="right">
                                <div className="sbt-data-grid__action-bar">
                                    <InfoIcon className='sba-grid-info-icon' />
                                    <Tooltip title="Preview" placement="top" arrow>
                                        <IconButton aria-label="delete" sx={{ ml: 1.5 }}>
                                            <VisibilityIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Edit" placement="top" arrow>
                                        <IconButton aria-label="delete" sx={{ ml: 0.5 }}>
                                            <EditIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete" placement="top" arrow>
                                        <IconButton aria-label="delete" sx={{ ml: 0.5 }}>
                                            <DeleteIcon color="error" />
                                        </IconButton>


                                    </Tooltip>
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                    {emptyRows > 0 && (
                        <TableRow
                            style={{
                                height: 53 * emptyRows,
                            }}
                        >
                            <TableCell colSpan={6} />
                        </TableRow>
                    )}

                </UiTableBody>
            </UiTableWrapper>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
    )
}
